var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Visa"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "BoundingBox",
    points: "0 0 88 0 88 88 72.2089844 88 0 88"
  }), /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(0.000000, 33.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#2566AF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1488263,25.2388557 L30.9682093,25.2388557 L35.4560027,0.443066215 L42.6373575,0.443066215 L38.1488263,25.2388557 Z M24.9274313,0.443066215 L18.0817572,17.4977991 L17.2716968,13.8252578 L17.2724346,13.8265843 L14.856271,2.67564238 C14.856271,2.67564238 14.564118,0.443066215 11.4500335,0.443066215 L0.132796781,0.443066215 L0,0.862917883 C0,0.862917883 3.46083166,1.51027211 7.51113347,3.69708246 L13.7496311,25.239519 L21.2312542,25.239519 L32.6554661,0.443066215 L24.9274313,0.443066215 Z M81.4066398,25.2388557 L88,25.2388557 L82.2513749,0.442402943 L76.4791415,0.442402943 C73.813615,0.442402943 73.1643863,2.2902809 73.1643863,2.2902809 L62.4550637,25.2388557 L69.9403756,25.2388557 L71.4372904,21.555702 L80.5655936,21.555702 L81.4066398,25.2388557 Z M73.5052314,16.4677365 L77.2781355,7.18855036 L79.4006707,16.4677365 L73.5052314,16.4677365 Z M63.016499,6.40588848 L64.0412475,1.08113463 C64.0412475,1.08113463 60.8792086,0 57.5828974,0 C54.0195171,0 45.5574111,1.40016883 45.5574111,8.20866389 C45.5574111,14.6145524 55.4891348,14.6941451 55.4891348,18.0589279 C55.4891348,21.4237107 46.5806841,20.8207958 43.6407109,18.6989861 L42.5731724,24.2664978 C42.5731724,24.2664978 45.7794769,25.6666667 50.6782025,25.6666667 C55.5784038,25.6666667 62.9707579,23.3856716 62.9707579,17.1774384 C62.9707579,10.730427 52.9497653,10.1301651 52.9497653,7.32717437 C52.950503,4.52352034 59.943729,4.88367746 63.016499,6.40588848 L63.016499,6.40588848 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.2724346,13.825921 L14.856271,2.67497911 C14.856271,2.67497911 14.564118,0.442402943 11.4500335,0.442402943 L0.132796781,0.442402943 L0,0.862254611 C0,0.862254611 5.43950369,1.87573541 10.6569416,5.67297207 C15.645674,9.3024007 17.2724346,13.825921 17.2724346,13.825921 Z",
    id: "Path",
    fill: "#E6A540"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card-visa.8c2e6e312c8c92462d6e2c8d5a17e28b.svg";
export { ForwardRef as ReactComponent };